<template>
  <Modal :open="open" :close="close">
    <div class="flex items-center justify-center">
      <button
        class="m-2 flex items-center font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        @click="switchToDestop"
      >
        <IconDesktop class="w-4 h-4 mr-2" />
        desktop
      </button>
      <button
        class="m-2 flex items-center font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        @click="switchToMobile"
      >
        <IconMobile class="w-4 h-4 mr-2" />
        phone
      </button>
    </div>
    <div
      ref="preview"
      style="zoom: 0.8"
      class="w-[1740px] h-[900px] ease-in-out transition-all duration-150 max-h-screen-90"
    >
      <iframe
        ref="preview_window"
        content="no-cache"
        class="z-10 w-full h-full"
        :src="`${url}/?time=${new Date().getTime()}`"
        frameborder="0"
      ></iframe>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Shared/Modal/Base";
import settings from "@/common/config";
import IconDesktop from "@/assets/icons/IconDesktop";
import IconMobile from "@/assets/icons/IconMobile";

export default {
  name: "CategoryPagePreviewModal",
  components: {
    Modal,
    IconDesktop,
    IconMobile
  },
  props: {
    close: {
      type: Function,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    domain() {
      return settings.AU_API_URL;
    }
  },
  methods: {
    switchToDestop() {
      const preview = this.$refs.preview;
      preview.style.height = "900px";
      preview.style.width = "1740px";
    },
    switchToMobile() {
      const preview = this.$refs.preview;
      preview.style.height = "896px";
      preview.style.width = "514px";
    }
  }
};
</script>
